import React, { useRef } from 'react';
import styles from './ScrollableSideBarItems.module.css';
import useScrollAffordance from './useScrollAffordance';

interface ScrollableSideBarItemsProps {
  children: React.ReactNode;
}

/**
 * Scrollable region for the sidebar's nav items, with an edge fade that appears
 * only when there is more to scroll in that direction.
 */
const ScrollableSideBarItems: React.FC<ScrollableSideBarItemsProps> = ({
  children,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { canScrollUp, canScrollDown } = useScrollAffordance(scrollRef);

  return (
    <div className={styles.container}>
      <div className={styles.fadeTop} data-visible={canScrollUp} aria-hidden />
      <div className={styles.scrollArea} ref={scrollRef}>
        {children}
      </div>
      <div
        className={styles.fadeBottom}
        data-visible={canScrollDown}
        aria-hidden
      />
    </div>
  );
};

export default ScrollableSideBarItems;
